module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAABUUlEQVQ4T9WT207CUBBFFyAtV7GgFExpiiD6/18jGgy2kavQcElLaUqNRpJyszXxQc/rmVmzZ2ZPzPd9n196sf8H8xwbx/MhlkBMiyQijOKwTXuK0RtjuYFRxgUyl1VqxfS3yF2YPaSrmzgxkYJcQcoJsF5iDobMHB9R0tBk8SRwBzbptnlbZ6g0ahR2+vKY6h3GqxRyS+XiBC4Am6K3R7jndRrVI9WtVzr6kmT5DrV4nBaADek+mCDdo8nHgsP+4UDZOqvQVHKHtLnBU88mdd2idh6qDObGI30riaTWKQcX51kMXgxmXhblViEbPjPAm2E897G8OGK+hCSlwTYxJwucDYhSE00+i7bNzyhvwcAYsVi5bL7S4kIGERvbFQ5VB9DRb3Or2k9RrGlcHfFvdNiHgq2p41kqN/te3NlmhOPbAnsOeUWltGfHnykLqfd3Ye9wHcbIAbGkLQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/ctcomponents/products/search.png
// module id = d6Q7
// module chunks = 0